import { render, staticRenderFns } from "./TemplateListFilters.vue?vue&type=template&id=22396605&"
import script from "./TemplateListFilters.vue?vue&type=script&lang=js&"
export * from "./TemplateListFilters.vue?vue&type=script&lang=js&"
import style0 from "./TemplateListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports